<template>
  <page>
    <v-card v-if="!currentRating" outlined>
      <v-btn text color="primary" @click="createRating()">
        <v-icon left>mdi-plus</v-icon>
        <span
          >Создать рейтинг на {{ currentSemester.number }} семестр
          {{ currentSemester.name }}</span
        >
      </v-btn>
    </v-card>
    <rating-editor
      v-if="currentRating"
      :rating="currentRating"
      @update="getRating"
    />
    <rating-sum-info
      class="mt-2"
      v-if="currentRating"
      :rating="currentRating"
    />
    <rating-activity-type-list
      class="mt-2"
      v-if="currentRating"
      :rating="currentRating"
      :activityTypes="activityTypes"
      @update="getRating"
    />
    <rating-rule-list
      class="mt-2"
      v-if="currentRating"
      :rating="currentRating"
      :activityTypes="activityTypes"
      @update="getRating"
    />
  </page>
</template>

<script>
import Page from "../../components/Page";
import RatingEditor from "../../components/rating/RatingEditor";
import RatingActivityTypeList from "../../components/rating/RatingActivityTypeList";
import RatingRuleList from "../../components/rating/RatingRuleList";
import RatingSumInfo from "../../components/rating/RatingSumInfo";

import {
  getCurrentSemester,
  getCurrentRating,
  listActivityType,
  createRating
} from "../../services/rating.service";

export default {
  name: "Rating",
  components: {
    Page,
    RatingEditor,
    RatingActivityTypeList,
    RatingRuleList,
    RatingSumInfo
  },

  data: () => ({
    currentRating: null,
    currentSemester: null,
    activityTypes: []
  }),

  async mounted() {
    await this.loadData();
    this.getRating();
  },

  methods: {
    async loadData() {
      try {
        this.currentSemester = await getCurrentSemester();
        this.activityTypes = await listActivityType();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async getRating() {
      try {
        this.currentRating = await getCurrentRating();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async createRating() {
      try {
        this.currentRating = await createRating(this.currentSemester.id);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    }
  }
};
</script>
